import React, { FC, useEffect, useState } from "react"
import Head from "next/head"
import { Navbar } from "@/components/general/Navbar"
import Image from "next/image"
import truck from "../public/images/bg-truck-img.png"
import waves from "../public/images/waves.png"
import lightWaves from "../public/images/light-waves.png"
import { useTheme } from "@/lib/context/ThemeContext"


type Props = {
  title: string
  children: JSX.Element | JSX.Element[]
}

export const Baselayout: FC<Props> = (props) => {
  const { isDarkMode } = useTheme()

  return (
    <>
      <Head>
        <title>{"BRONCO - " + props.title}</title>
        <link rel="bronco icon" href="/bronco.png" />
      </Head>
      <Navbar />
      <div className="dark:bg-opacity-30 dark:bg-primary-1 bg-login">
        {/* <Image
          className="md:w-auto w-11/12 h-full absolute left-0"
          src={truck.src}
          alt="bg truck img"
          width={100}
          height={100}
        /> */}
        {/* <div className="absolute flex items-end h-screen base-layout">
          {
            isDarkMode === false ? (
              <Image
                className="w-full"
                src={lightWaves.src}
                alt="bg waves img"
                width={100}
                height={100}
              />
            ) : (
              <Image
                className="w-full"
                src={waves.src}
                alt="bg waves img"
                width={100}
                height={100}
              />
            )
          }
        </div> */}
        <div>{props.children}</div>
      </div>
    </>
  )
}
